import { createContext } from 'react'
import type { User } from '@/types'

export interface AuthState {
  user: User | null
  /** True until the initial session probe resolves. Nothing client-scoped fetches before then. */
  loading: boolean
  error: string | null
  /** `next` is a same-origin relative path, restored after the identity provider returns. */
  signIn: (next?: string) => Promise<void>
  signOut: () => Promise<void>
}

export const AuthContext = createContext<AuthState | null>(null)
